import { Bitcoin, Bnb, Eth, Shiba, Solana, Tron, Trump, Usdt, Vatan } from '@repo/icons';

export const FOOTER_PAYMENT_ITEMS = [
  {
    id: 'VATAN',
    Icon: Vatan,
    href: '/account/deposit',
  },
  {
    id: 'USDT',
    Icon: Usdt,
    href: '/account/deposit',
  },
  {
    id: 'TRON',
    Icon: Tron,
    href: '/account/deposit',
  },
  {
    id: 'SOLANA',
    Icon: Solana,
    href: '/account/deposit',
  },
  {
    id: 'TRUMP',
    Icon: Trump,
    href: '/account/deposit',
  },
  {
    id: 'BTC',
    Icon: Bitcoin,
    href: '/account/deposit',
  },
  {
    id: 'BNB',
    Icon: Bnb,
    href: '/account/deposit',
  },
  {
    id: 'ETH',
    Icon: Eth,
    href: '/account/deposit',
  },
  {
    id: 'SHIB',
    Icon: Shiba,
    href: '/account/deposit',
  },
];
